import axios from "axios";
import { endpoint } from "../../config";
import { customToast } from "../../lib/toastLib";

const productListApi = async (partnerName) => {
  try {
    let apiLink = null;
    if (partnerName) {
      apiLink = `${endpoint}/api/product-list/${partnerName}`;
    } else {
      apiLink = `${endpoint}/api/product-list`;
    }
    const response = await axios.get(apiLink);
    const data = response.data;

    const dataArray = [];
    if (data && data.data) {
      data.data.forEach((obj) => {
        const productObj = {
          id: obj.category_id || null,
          name: obj.category_name || "",
          productBannerUrl: obj.category_img_thumb || "",
          subcategories: obj.subcategories,
          landing_url: obj.landing_url,
          long_description: obj.long_description || ""
        };
        dataArray.push(productObj);
      });
    }

    return dataArray;
  } catch (error) {
    if (error.response) {
      customToast.error(error.response.data?.message);
    } else {
      customToast.error(error.message);
    }
    throw error;
  }
};

export default productListApi;
